<template>
    <!-- 科研绘图 -->
    <div>
        <div class="top_img_content">
            <img class="top_img1" src="../../assets/img/keyanhuitu.jpg" />
        </div>
        <div class="list_main white_main">
            <div class="commonTitle"></div>
            <div class="cardList">
                <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
                    <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(i, index) in exhibitImage"
                        :key="i + index + 'a'">
                        <img class="scienceImg" :src="i.img" />
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- <div class="list_main white_main">
            <div class="commonTitle">
                <h3 class="itemTitleBorder">
                    <div class="itemTitleBorderName">封面图</div>
                </h3>
                <div class="subTitle">在期刊首页封面位置，根据期刊要求，要体现文章内容或者研究方向，一般由期刊名称及网址等信息组成，内容可具体可抽象，贵在创意！ </div>
            </div>
            <div class="cardList">
                <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
                    <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(i, index) in coverImage"
                        :key="i + index + 'a'">
                        <img class="scienceImg" :src="i.img" />
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="list_main white_main">
            <div class="commonTitle">
                <h3 class="itemTitleBorder">
                    <div class="itemTitleBorderName">摘要图</div>
                </h3>
                <div class="subTitle">图文摘要TOC的图片是一篇优秀的文章中不可或缺的一部分，也往往是读者第一眼看到的。一篇文章拥有一幅漂亮的TOC图能加分不少。</div>
            </div>
            <div class="cardList">
                <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
                    <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(i, index) in tocImage"
                        :key="i + index + 'a'">
                        <img class="scienceImg" :src="i.img" />
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="list_main white_main pd-bm50">
            <div class="commonTitle">
                <h3 class="itemTitleBorder">
                    <div class="itemTitleBorderName">流程图</div>
                </h3>
                <div class="subTitle"> 文章流程图是使用图形表示反应机理货这步骤的思路是一种极好的方法，因为千言万语不如一张图。 </div>
            </div>
            <div class="cardList">
                <el-row :gutter="70" type="flex" style="flex-wrap: wrap;">
                    <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6" v-for="(i, index) in flowChart"
                        :key="i + index + 'a'">
                        <img class="scienceImg" :src="i.img" />
                    </el-col>
                </el-row>
            </div>
        </div> -->
        <div class="list_main">
            <div class="commonTitle">
                <h3 class="itemTitle itemTitleMargin">科研绘图服务流程</h3>
                <div class="cardList cloud_flow_list">
                    <div class="testList">
                        <div v-for="item in cloudTestFlowList" :key="item.index" :span="4" class="test_col">
                            <div class="flow_next">
                                <img src="../../assets/img/next.png" />
                            </div>
                            <div class="testFlow_card">
                                <img class="testFlow_img" :src="item.src" />
                                <div class="testFlow_Name">{{ item.name }}</div>
                                <div class="testFlow_content">{{ item.content }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="list_main submitRequire">
            <contentIndex :initInfo="info"></contentIndex>
        </div>
    </div>
</template>
<script>
import uploadText from "../common/uploadText"
import requireNotice from "./requireNotice.vue"
import contentIndex from "./index.vue"

export default {
    components: {
        uploadText,requireNotice, contentIndex
    },
    data() {
        return {
            info: {
              type: 10,
              testTypeList: [],
            },
            exhibitImage: [
                { img: require("../../assets/img/exhibitImage1.jpg") },
                { img: require("../../assets/img/exhibitImage2.jpg") },
                { img: require("../../assets/img/exhibitImage3.jpg") },
                { img: require("../../assets/img/exhibitImage4.jpg") },
                // { img: require("../../assets/img/exhibitImage5.jpg") },
                // { img: require("../../assets/img/exhibitImage6.jpg") },
            ],
            coverImage: [
                { img: require("../../assets/img/coverImage1.jpg") },
                { img: require("../../assets/img/coverImage2.jpg") },
                { img: require("../../assets/img/coverImage3.jpg") },
                { img: require("../../assets/img/coverImage4.jpg") }
            ],
            tocImage:[
                { img: require("../../assets/img/tocImage1.jpg") },
                { img: require("../../assets/img/tocImage2.jpg") },
                { img: require("../../assets/img/tocImage3.jpg") },
                { img: require("../../assets/img/tocImage4.jpg") }
            ],
            flowChart:[
                { img: require("../../assets/img/flowChart1.jpg") },
                { img: require("../../assets/img/flowChart2.jpg") },
                { img: require("../../assets/img/flowChart3.jpg") },
                { img: require("../../assets/img/flowChart4.jpg") }
            ],
            cloudTestFlowList: [
                {
                    name: "1.提交需求",
                    content: "填写具体需求并提交；建议准备好详细介绍文字、草图、 参考图等，可加快沟通进展；",
                    src: require("../../assets/img/tjxq.png")
                },
                {
                    name: "2.沟通细节",
                    content: "确认要求、预估周期、具体费用等。",
                    src: require("../../assets/img/gtxj.png")
                },
                {
                    name: "3.确认需求",
                    content: "要求、周期以及费用无异议后， 开启作图流程",
                    src: require("../../assets/img/qrxq.png")
                },
                {
                    name: "4.确认初稿",
                    content: "3-5个工作日给出初稿，经过确认无误后按照细节继续完善图稿",
                    src: require("../../assets/img/qrcg.png")
                },
                {
                    name: "5.交付定稿",
                    content: "终稿完成后，所有不动大结构的修改全部免费，直到您满意为止",
                    src: require("../../assets/img/jfdg.png")
                }
            ],
        }
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
.scienceImg {
    width: 90%;
}

.testFlow_card {
    text-align: center;
    padding: 30px;
    width: 210px;
}

.flow_next {
    img {
        width: 45%;
    }

    position: absolute;
    right: -60px;
    top: 33%;
}

.testFlow_img {
    width: 45%;
}

.testList {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
}

.test_col {
    position: relative;
}

.testFlow_Name {
    color: #333333;
    font-size: 16px;
    line-height: 27px;
    font-weight: 500;
    margin: 10px;
}

.testFlow_content {
    color: #999999;
    font-size: 13px;
    line-height: 25px;
    height: 80px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.test_col:last-child .flow_next {
    display: none;
}
</style>